import { DateEditor, TextEditor } from 'handsontable/editors'

// EVA-155 / EVA-358: preserve Handsontable's ISO date handling while keeping
// native date input editing predictable. Browsers retain the active day/month/year
// segment on a reused input, so each edit needs a fresh element. Handsontable 18's
// DateEditor also opens the picker programmatically; the calendar must remain an
// explicit user action through the input's native calendar control.
export class NativeDateEditor extends DateEditor {
  open() {
    const value = this.TEXTAREA.value
    const freshInput = this.TEXTAREA.cloneNode(false)
    freshInput.value = value

    this.autoResize.unObserve()
    this.eventManager.removeEventListener(this.TEXTAREA, 'focusout')
    this.TEXTAREA_PARENT.replaceChild(freshInput, this.TEXTAREA)
    this.TEXTAREA = freshInput
    this.textareaStyle = freshInput.style

    // TextEditor binds this handler only to the input created at construction
    // time. Rebind it when replacing that input so iOS's Done button still
    // commits and closes the editor.
    if (/iPhone|iPad|iPod/i.test(this.hot.rootWindow.navigator.platform)) {
      this.eventManager.addEventListener(this.TEXTAREA, 'focusout', () => this.finishEditing(false))
    }

    TextEditor.prototype.open.call(this)
  }

  // DateEditor#focus selects the reused input. A fresh native date input only
  // needs focus; the browser then starts keyboard input at its first segment.
  focus() {
    this.TEXTAREA.focus()
  }
}
